var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, react/forbid-prop-types, react/jsx-closing-bracket-location, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var classNames = require("classnames");
var React = require("react");
var _ = require("underscore");

var ApiOptions = require("../perseus-api.jsx").Options;
var Changeable = require("../mixins/changeable.jsx");
var Renderer = require("../renderer.jsx");

var _require = require("../gorgon/proptypes.js"),
    linterContextProps = _require.linterContextProps,
    linterContextDefault = _require.linterContextDefault;

var Group = React.createClass({
    displayName: "Group",

    propTypes: _extends({}, Changeable.propTypes, {
        content: React.PropTypes.string,
        widgets: React.PropTypes.object,
        images: React.PropTypes.object,
        icon: React.PropTypes.object,
        reviewModeRubric: React.PropTypes.object,
        linterContext: linterContextProps
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            content: "",
            widgets: {},
            images: {},
            icon: null,
            linterContext: linterContextDefault
        };
    },

    componentDidMount: function componentDidMount() {
        // TODO(marcia): See comment in render method about our cyclical
        // numbering scheme. We force another render so that we can annotate
        // the group with the correct number.
        this.forceUpdate();
    },

    render: function render() {
        var _this = this;

        var apiOptions = _.extend({}, ApiOptions.defaults, this.props.apiOptions, {
            // Api Rewriting to support correct onFocus/onBlur
            // events for the mobile API
            onFocusChange: function onFocusChange(newFocus, oldFocus) {
                if (oldFocus) {
                    _this.props.onBlur(oldFocus);
                }
                if (newFocus) {
                    _this.props.onFocus(newFocus);
                }
            }
        });

        // Allow a problem number annotation to be added.
        // This is cyclical and should probably be reconsidered. In order to
        // render the annotation ("Question 3 of 10"), we call findWidgets to
        // figure out our index in the list of all fellow group widgets. On
        // first render, though, we don't exist yet in this list, and so we
        // give ourselves number -1. To combat this, we forceUpdate in
        // componentDidMount so that we can number ourselves properly. But,
        // really we should have a more unidirectional flow. TODO(marcia): fix.
        var number = _.indexOf(this.props.findWidgets("group"), this);
        var problemNumComponent = this.props.apiOptions.groupAnnotator(number, this.props.widgetId);

        // This is a little strange because the id of the widget that actually
        // changed is going to be lost in favor of the group widget's id. The
        // widgets prop also wasn't actually changed, and this only serves to
        // alert our renderer (our parent) of the fact that some interaction
        // has occurred.
        var onInteractWithWidget = function onInteractWithWidget(id) {
            if (_this.refs.renderer) {
                _this.change("widgets", _this.refs.renderer.props.widgets);
            }
        };

        var score = this.refs.renderer && this.refs.renderer.score();
        var isValid = score && score.type !== "invalid";
        var isInvalid = score && score.type === "invalid";

        // TODO(mdr): Widgets inside this Renderer are not discoverable through
        //     the parent Renderer's `findWidgets` function.
        return React.createElement(
            "div",
            {
                className: classNames({
                    "perseus-group": true,
                    "perseus-group-valid-answer": isValid,
                    "perseus-group-invalid-answer": isInvalid
                })
            },
            problemNumComponent,
            React.createElement(Renderer, _extends({}, this.props, {
                ref: "renderer",
                apiOptions: apiOptions,
                findExternalWidgets: this.props.findWidgets,
                reviewMode: !!this.props.reviewModeRubric,
                onInteractWithWidget: onInteractWithWidget,
                linterContext: this.props.linterContext
            })),
            this.props.icon && React.createElement(
                "div",
                { className: "group-icon" },
                this.props.icon
            )
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    getUserInput: function getUserInput() {
        return this.refs.renderer.getUserInput();
    },

    getSerializedState: function getSerializedState() {
        return this.refs.renderer.getSerializedState();
    },

    restoreSerializedState: function restoreSerializedState(state, callback) {
        this.refs.renderer.restoreSerializedState(state, callback);
        // Tell our renderer that we have no props to change
        // (all our changes were in state):
        return null;
    },

    simpleValidate: function simpleValidate(rubric) {
        return this.refs.renderer.score();
    },

    // Mobile API:
    getInputPaths: function getInputPaths() {
        return this.refs.renderer.getInputPaths();
    },

    setInputValue: function setInputValue(path, newValue, cb) {
        return this.refs.renderer.setInputValue(path, newValue, cb);
    },

    getAcceptableFormatsForInputPath: function getAcceptableFormatsForInputPath(path) {
        return this.refs.renderer.getAcceptableFormatsForInputPath(path);
    },

    /**
     * WARNING: This is an experimental/temporary API and should not be relied
     *     upon in production code. This function may change its behavior or
     *     disappear without notice.
     *
     * This function was created to allow Renderer.getAllWidgetIds to descend
     * into our renderer.
     */
    getRenderer: function getRenderer() {
        return this.refs.renderer;
    },

    focus: function focus() {
        return this.refs.renderer.focus();
    },

    focusInputPath: function focusInputPath(path) {
        this.refs.renderer.focusPath(path);
    },

    blurInputPath: function blurInputPath(path) {
        this.refs.renderer.blurPath(path);
    },

    showRationalesForCurrentlySelectedChoices: function showRationalesForCurrentlySelectedChoices() {
        this.refs.renderer.showRationalesForCurrentlySelectedChoices();
    }
});

var traverseChildWidgets = function traverseChildWidgets(props, traverseRenderer) {
    return _.extend({}, props, traverseRenderer(props));
};

module.exports = {
    name: "group",
    displayName: "Group (SAT only)",
    widget: Group,
    traverseChildWidgets: traverseChildWidgets,
    hidden: false,
    isLintable: true
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/group.jsx
 ** module id = 110
 ** module chunks = 0 1
 **/